export default {
    getCategoryById: (state, getters) => id => {
        return state.categories[id];
    }
};
